import * as yup from 'yup'
import i18n from '../i18n'

export const LoginFormValidate = yup.object().shape({
  email: yup
    .string()
    .email(i18n.t('login.email.invalid', { ns: 'resources.form-validator' }))
    .required(i18n.t('login.email.required', { ns: 'resources.form-validator' })),
  password: yup
    .string()
    .required(i18n.t('login.password.required', { ns: 'resources.form-validator' })),
})

export const CAFormValidate = yup.object().shape({
  revrex_account_id: yup.number().nullable(),
  account: yup
    .object()
    .shape({
      label: yup
        .string()
        .required(
          i18n.t('ca.account.label.required', {
            ns: 'resources.form-validator',
          })
        ),
      value: yup
        .string()
        .required(
          i18n.t('ca.account.value.required', {
            ns: 'resources.form-validator',
          })
        ),
    })
    .typeError(
      i18n.t('ca.account.type_error', { ns: 'resources.form-validator' })
    )
    .required(
      i18n.t('ca.account.required', { ns: 'resources.form-validator' })
    ),
  financial_statement: yup
    .object()
    .shape({
      label: yup.string().required( i18n.t('ca.financial_statement.label.required', { ns: 'resources.form-validator' })),
      value: yup.string().required( i18n.t('ca.financial_statement.value.required', { ns: 'resources.form-validator' })),
    })
    .required( i18n.t('ca.financial_statement.required', { ns: 'resources.form-validator' })),
  parenthisys_control: yup
    .object()
    .shape({
      label: yup.string().required( i18n.t('ca.parenthisys_control.label.required', { ns: 'resources.form-validator' })),
      value: yup.string().required( i18n.t('ca.parenthisys_control.value.required', { ns: 'resources.form-validator' })),
    })
    .required( i18n.t('ca.parenthisys_control.required', { ns: 'resources.form-validator' })),
  name: yup.string().required(i18n.t('ca.name.required', { ns: 'resources.form-validator' })),
  description: yup.string(),
})

export const GLSearchFormValidate = yup.object().shape({
  month: yup
    .object()
    .shape({
      label: yup.string().required(i18n.t('gl_search.month.label.required', { ns: 'resources.form-validator' })),
      value: yup.string().required(i18n.t('gl_search.month.value.required', { ns: 'resources.form-validator' })),
    })
    .required(i18n.t('gl_search.month.required', { ns: 'resources.form-validator' })),
  year: yup
    .object()
    .shape({
      label: yup.string().required(i18n.t('gl_search.year.label.required', { ns: 'resources.form-validator' })),
      value: yup.string().required(i18n.t('gl_search.year.value.required', { ns: 'resources.form-validator' })),
    })
    .required(i18n.t('gl_search.year.required', { ns: 'resources.form-validator' })),
})

export const SalesExpenseValidate = yup.object().shape({
  sales: yup.array().of(
    yup.object().shape({
      checked: yup.boolean(),
      //id: yup.any(),
      parent_id: yup.number(),
      description: yup.string().nullable(),
      account_name: yup.string().nullable(),
      transaction_at: yup.string(),
      gross_sale: yup.number(),
      state_tax: yup.number(),
      // adjusted_bank_deposit: yup.number(),
      overshort: yup.number(),
      split: yup.array(),
      account_type: yup.string(),

      gross_sale_master_account_id: yup
        .object()
        .when(['gross_sale', 'checked', 'split', 'account_type'], {
          // is: (grossSale: number, isChecked: boolean) => +grossSale && isChecked,
          is: (
            grossSale: number,
            isChecked: boolean,
            split: any[],
            account_type: string
          ) => {
            return (
              +grossSale &&
              isChecked &&
              split.length === 0 &&
              account_type === 'Gross_Sale'
            )
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('sales.gross_sale_master_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('sales.gross_sale_master_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('sales.gross_sale_master_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('sales.gross_sale_master_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      state_tax_master_account_id: yup
        .object()
        .when(['state_tax', 'checked', 'split', 'account_type'], {
          is: (
            stateTax: number,
            isChecked: boolean,
            split: any[],
            account_type: string
          ) => {
            return (
              +stateTax &&
              isChecked &&
              split.length === 0 &&
              account_type === 'State_Tax'
            )
          },
          //is: (stateTax: number, isChecked: boolean, account_type: string) => +stateTax && isChecked && account_type == 'State_Tax',
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('sales.state_tax_master_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('sales.state_tax_master_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('sales.state_tax_master_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('sales.state_tax_master_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      adjusted_bank_deposit_master_account_id: yup
        .object()
        .when(['amount', 'checked', 'split', 'account_type'], {
          is: (
            amount: number,
            isChecked: boolean,
            split: any[],
            account_type: string
          ) => {
            return (
              +amount &&
              isChecked &&
              split.length === 0 &&
              account_type === 'Adjusted_Bank_Deposit'
            )
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('sales.gross_sale_master_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('sales.gross_sale_master_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('sales.gross_sale_master_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('sales.gross_sale_master_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      overshort_master_account_id: yup
        .object()
        .when(['overshort', 'checked', 'account_type'], {
          //is: (overshort: number, isChecked: boolean, account_type: string) => +overshort && isChecked && account_type == 'Overshort',
          is: (overshort: number, isChecked: boolean, account_type: string) => {
            return +overshort && isChecked && account_type === 'Overshort'
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('sales.overshort_master_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('sales.overshort_master_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('sales.overshort_master_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('sales.overshort_master_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
    })
  ),
})
export const BankExpenseValidate = yup.object().shape({
  banks: yup.array().of(
    yup.object().shape({
      checked: yup.boolean(),
      id: yup.number(),
      parent_id: yup.number(),
      description: yup.string().nullable(),
      account_name: yup.string().nullable(),
      transaction_at: yup.string(),
      deposit: yup.number(),
      split: yup.array(),
      // equity: yup.number(),
      // bank_transfer: yup.number(),
      // others: yup.number(),
      // adjusted_bank_deposit: yup.number(),
      deposit_debit_account_id: yup
        .object()
        .when(['deposit', 'checked', 'split'], {
          is: (deposit: number, isChecked: boolean, split: any[]) => {
            return +deposit && isChecked && split.length === 0
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('bank_expense.deposit_debit_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('bank_expense.deposit_debit_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('bank_expense.deposit_debit_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('bank_expense.deposit_debit_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      deposit_credit_account_id: yup
        .object()
        .when(['deposit', 'checked', 'split'], {
          is: (deposit: number, isChecked: boolean, split: any[]) => {
            return +deposit && isChecked && split.length === 0
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('bank_expense.deposit_credit_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('bank_expense.deposit_credit_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('bank_expense.deposit_credit_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('bank_expense.deposit_credit_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      /*equity_master_account_id: yup.object().when(['equity', 'checked'], {
                is: (equity: number, isChecked: boolean) => +equity && isChecked,
                then: (schema: any) => schema.shape({
                    label: yup.string().required('GL is required'),
                    value: yup.string().required('GL is required'),
                }).typeError('GL is required').required('GL is required'),
                otherwise: (schema: any) => schema.nullable()
            }),
            bank_transfer_master_account_id: yup.object().when(['bank_transfer', 'checked'], {
                is: (bankTransfer: number, isChecked: boolean) => +bankTransfer && isChecked,
                then: (schema: any) => schema.shape({
                    label: yup.string().required('GL is required'),
                    value: yup.string().required('GL is required'),
                }).typeError('GL is required').required('GL is required'),
                otherwise: (schema: any) => schema.nullable()
            }),
            others_master_account_id: yup.object().when(['others', 'checked'], {
                is: (others: number, isChecked: boolean) => +others && isChecked,
                then: (schema: any) => schema.shape({
                    label: yup.string().required('GL is required'),
                    value: yup.string().required('GL is required'),
                }).typeError('GL is required').required('GL is required'),
                otherwise: (schema: any) => schema.nullable()
            }),
            adjusted_bank_deposity_master_account_id: yup.object().when(['adjusted_bank_deposit', 'checked'], {
                is: (adjustedBankDeposit: number, isChecked: boolean) => +adjustedBankDeposit && isChecked,
                then: (schema: any) => schema.shape({
                    label: yup.string().required('GL is required'),
                    value: yup.string().required('GL is required'),
                }).typeError('GL is required').required('GL is required'),
                otherwise: (schema: any) => schema.nullable()
            }),*/
    })
  ),
})
export const BankRevenueValidate = yup.object().shape({
  revenues: yup.array().of(
    yup.object().shape({
      checked: yup.boolean(),
      id: yup.number(),
      parent_id: yup.number(),
      description: yup.string().nullable(),
      account_name: yup.string().nullable(),
      transaction_at: yup.string(),
      deposit: yup.number(),
      equity: yup.number(),
      bank_transfer: yup.number(),
      others: yup.number(),
      adjusted_bank_deposit: yup.number(),
      equity_split: yup.array(),
      bank_transfer_split: yup.array(),
      others_split: yup.array(),
      deposit_master_account_id: yup.object().when(['deposit', 'checked'], {
        is: (deposit: number, isChecked: boolean) => {
          return +deposit && isChecked
        },
        then: (schema: any) =>
          schema
            .shape({
              label: yup.string().required(i18n.t('bank_revenue.deposit_master_account_id.label.required', { ns: 'resources.form-validator' })),
              value: yup.string().required(i18n.t('bank_revenue.deposit_master_account_id.value.required', { ns: 'resources.form-validator' })),
            })
            .typeError(i18n.t('bank_revenue.deposit_master_account_id.type_error', { ns: 'resources.form-validator' }))
            .required(i18n.t('bank_revenue.deposit_master_account_id.required', { ns: 'resources.form-validator' })),
        otherwise: (schema: any) => schema.nullable(),
      }),
      equity_master_account_id: yup
        .object()
        .when(['equity', 'checked', 'equity_split'], {
          //is: (equity: number, isChecked: boolean) => +equity && isChecked,
          is: (equity: number, isChecked: boolean, equity_split: any[]) => {
            return +equity && isChecked && equity_split.length === 0
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('bank_revenue.equity_master_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('bank_revenue.equity_master_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('bank_revenue.equity_master_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('bank_revenue.equity_master_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      bank_transfer_master_account_id: yup
        .object()
        .when(['bank_transfer', 'checked', 'bank_transfer_split'], {
          //is: (bankTransfer: number, isChecked: boolean) => +bankTransfer && isChecked,
          is: (
            bankTransfer: number,
            isChecked: boolean,
            bank_transfer_split: any[]
          ) => {
            return (
              +bankTransfer && isChecked && bank_transfer_split.length === 0
            )
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('bank_revenue.bank_transfer_master_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('bank_revenue.bank_transfer_master_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('bank_revenue.bank_transfer_master_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('bank_revenue.bank_transfer_master_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      others_master_account_id: yup
        .object()
        .when(['others', 'checked', 'others_split'], {
          // is: (others: number, isChecked: boolean) => +others && isChecked,
          is: (others: number, isChecked: boolean, others_split: any[]) => {
            return +others && isChecked && others_split.length === 0
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('bank_revenue.others_master_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('bank_revenue.others_master_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('bank_revenue.others_master_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('bank_revenue.others_master_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      /*adjusted_bank_deposity_master_account_id: yup.object().when(['adjusted_bank_deposit', 'checked'], {
                is: (adjustedBankDeposit: number, isChecked: boolean) => +adjustedBankDeposit && isChecked,
                then: (schema: any) => schema.shape({
                    label: yup.string().required('GL is required'),
                    value: yup.string().required('GL is required'),
                }).typeError('GL is required').required('GL is required'),
                otherwise: (schema: any) => schema.nullable()
            }),*/
    })
  ),
})
export const BankReconcileValidate = yup.object().shape({
  reconciles: yup.array().of(
    yup.object().shape({
      checked: yup.boolean(),
      id: yup.number(),
    })
  ),
})
export const SettingsBudgetValidate = yup.object().shape({
  budget_based_on: yup
    .object({
      label: yup
        .string()
        .required(
          i18n.t('settings_budget.budget_based_on.label.required', {
            ns: 'resources.form-validator',
          })
        ),
      value: yup
        .number()
        .required(
          i18n.t('settings_budget.budget_based_on.value.required', {
            ns: 'resources.form-validator',
          })
        ),
    })
    .typeError(
      i18n.t('settings_budget.budget_based_on.type_error', {
        ns: 'resources.form-validator',
      })
    )
    .required(
      i18n.t('settings_budget.budget_based_on.required', {
        ns: 'resources.form-validator',
      })
    ),

  // Calendar (value = 1)
  first_month_of_income_tax_year: yup
    .object()
    .nullable()
    .when('budget_based_on', ([budget], schema) => {
      if (budget?.value === 2) {
        return yup
          .object({
            label: yup
              .string()
              .required(
                i18n.t(
                  'settings_budget.first_month_of_income_tax_year.label.required',
                  { ns: 'resources.form-validator' }
                )
              ),
            value: yup
              .string()
              .required(
                i18n.t(
                  'settings_budget.first_month_of_income_tax_year.value.required',
                  { ns: 'resources.form-validator' }
                )
              ),
          })
          .required(
            i18n.t('settings_budget.first_month_of_income_tax_year.required', {
              ns: 'resources.form-validator',
            })
          )
      }
      return schema.notRequired()
    }),

  // Fiscal (value = 2)
  first_month_of_fiscal_year: yup
    .object()
    .nullable()
    .when('budget_based_on', ([budget], schema) => {
      if (budget?.value === 1) {
        return yup
          .object({
            label: yup
              .string()
              .required(
                i18n.t(
                  'settings_budget.first_month_of_fiscal_year.label.required',
                  { ns: 'resources.form-validator' }
                )
              ),
            value: yup
              .string()
              .required(
                i18n.t(
                  'settings_budget.first_month_of_fiscal_year.value.required',
                  { ns: 'resources.form-validator' }
                )
              ),
          })
          .required(
            i18n.t('settings_budget.first_month_of_fiscal_year.required', {
              ns: 'resources.form-validator',
            })
          )
      }
      return schema.notRequired()
    }),
})

export const SalesValidate = yup.object().shape({
  gl_account: yup
    .object()
    .shape({
      label: yup.string().required(
        i18n.t('sales_validate.gl_account.label.required', {
          ns: 'resources.form-validator',
        })
      ),
      value: yup.string().required(
        i18n.t('sales_validate.gl_account.value.required', {
          ns: 'resources.form-validator',
        })
      ),
    })
    .typeError(
      i18n.t('sales_validate.gl_account.type_error', {
        ns: 'resources.form-validator',
      })
    )
    .required(
      i18n.t('sales_validate.gl_account.required', {
        ns: 'resources.form-validator',
      })
    ),
})

export const BudgetValidate = yup.object().shape({
  budgets: yup.array().of(
    yup.object().shape({
      master_chart_of_account_number: yup.string(),
      master_chart_of_account_name: yup.string(),
      master_chart_of_account_id: yup.number(),
      parent_id: yup.number(),
      month_0: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_1: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_2: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_3: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_4: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_5: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_6: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_7: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_8: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_9: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_10: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
      month_11: yup.object().shape({
        amount: yup.string().typeError(i18n.t('budget_validate.month.amount.type_error', { ns: 'resources.form-validator' })),
        is_editable: yup.boolean(),
      }),
    })
  ),
})

export const RevRexBankAccSyncGlValidate = yup.object().shape({
  banks: yup
    .array()
    .of(
      yup.object().shape({
        bank_account_id: yup
          .object()
          .shape({
            label: yup.string().required(i18n.t('revrex_bank_acc_sync_gl.bank_account_id.label.required', { ns: 'resources.form-validator' })),
            value: yup.string().required(i18n.t('revrex_bank_acc_sync_gl.bank_account_id.value.required', { ns: 'resources.form-validator' })),
          })
          .typeError(i18n.t('revrex_bank_acc_sync_gl.bank_account_id.type_error', { ns: 'resources.form-validator' }))
          .required(i18n.t('revrex_bank_acc_sync_gl.bank_account_id.required', { ns: 'resources.form-validator' })),
        gl_account: yup
          .object()
          .shape({
            label: yup.string().required(i18n.t('revrex_bank_acc_sync_gl.gl_account.label.required', { ns: 'resources.form-validator' })),
            value: yup.string().required(i18n.t('revrex_bank_acc_sync_gl.gl_account.value.required', { ns: 'resources.form-validator' })),
          })
          .typeError(i18n.t('revrex_bank_acc_sync_gl.gl_account.type_error', { ns: 'resources.form-validator' }))
          .required(i18n.t('revrex_bank_acc_sync_gl.gl_account.required', { ns: 'resources.form-validator' })),
      })
    )
    .test(
      'unique_gl',
      i18n.t('revrex_bank_acc_sync_gl.unique_gl', { ns: 'resources.form-validator' }),
      (values: any) => {
        const gl_acc: string[] = values
          .filter(
            (value: any) => value['gl_account'] && value['gl_account']['value']
          )
          .map((value: any) => value['gl_account']['value'])
        if (values.length == gl_acc.length) {
          let findDuplicates = gl_acc.filter(
            (item: string, index: number) => gl_acc.indexOf(item) !== index
          )
          return findDuplicates.length ? false : true
        } else {
          return true
        }
      }
    ),
})
export const RevRexBankAccAddGlValidate = yup.object().shape({
  branch_id: yup.number(),
  name: yup
    .object()
    .shape({
      label: yup.string().required(
        i18n.t('revrex_bank_acc_add_gl.name.label.required', {
          ns: 'resources.form-validator',
        })
      ),
      value: yup.string().required(
        i18n.t('revrex_bank_acc_add_gl.name.value.required', {
          ns: 'resources.form-validator',
        })
      ),
    })
    .required(
      i18n.t('revrex_bank_acc_add_gl.name.required', {
        ns: 'resources.form-validator',
      })
    )
    .typeError(
      i18n.t('revrex_bank_acc_add_gl.name.type_error', {
        ns: 'resources.form-validator',
      })
    ),
  number: yup
    .number()
    .min(
      0,
      i18n.t('revrex_bank_acc_add_gl.number.min', {
        ns: 'resources.form-validator',
      })
    )
    .max(
      9999,
      i18n.t('revrex_bank_acc_add_gl.number.max', {
        ns: 'resources.form-validator',
      })
    )
    .typeError(
      i18n.t('revrex_bank_acc_add_gl.number.type_error', {
        ns: 'resources.form-validator',
      })
    )
    .required(
      i18n.t('revrex_bank_acc_add_gl.number.required', {
        ns: 'resources.form-validator',
      })
    ),
  desc: yup
    .string()
    .min(
      5,
      i18n.t('revrex_bank_acc_add_gl.desc.min', {
        ns: 'resources.form-validator',
      })
    )
    .max(
      100,
      i18n.t('revrex_bank_acc_add_gl.desc.max', {
        ns: 'resources.form-validator',
      })
    )
    .required(
      i18n.t('revrex_bank_acc_add_gl.desc.required', {
        ns: 'resources.form-validator',
      })
    ),
  gl_account: yup
    .object()
    .shape({
      label: yup.string().required(
        i18n.t('revrex_bank_acc_add_gl.gl_account.label.required', {
          ns: 'resources.form-validator',
        })
      ),
      account: yup.mixed().required(
        i18n.t('revrex_bank_acc_add_gl.gl_account.required', {
          ns: 'resources.form-validator',
        })
      ),
    })
    .typeError(
      i18n.t('revrex_bank_acc_add_gl.gl_account.type_error', {
        ns: 'resources.form-validator',
      })
    )
    .required(
      i18n.t('revrex_bank_acc_add_gl.gl_account.required', {
        ns: 'resources.form-validator',
      })
    ),
})

export const RevRexSaleAccSyncGlValidate = yup.object().shape({
  sales: yup
    .array()
    .of(
      yup.object().shape({
        sale_account_id: yup
          .object()
          .shape({
            label: yup.string().required(i18n.t('revrex_sale_acc_sync_gl.sale_account_id.label.required', { ns: 'resources.form-validator' })),
            value: yup.string().required(i18n.t('revrex_sale_acc_sync_gl.sale_account_id.value.required', { ns: 'resources.form-validator' })),
          })
          .typeError(i18n.t('revrex_sale_acc_sync_gl.sale_account_id.type_error', { ns: 'resources.form-validator' }))
          .required(i18n.t('revrex_sale_acc_sync_gl.sale_account_id.required', { ns: 'resources.form-validator' })),
        gl_account: yup
          .object()
          .shape({
            label: yup.string().required(i18n.t('revrex_sale_acc_sync_gl.gl_account.label.required', { ns: 'resources.form-validator' })),
            value: yup.string().required(i18n.t('revrex_sale_acc_sync_gl.gl_account.value.required', { ns: 'resources.form-validator' })),
          })
          .typeError(i18n.t('revrex_sale_acc_sync_gl.gl_account.type_error', { ns: 'resources.form-validator' }))
          .required(i18n.t('revrex_sale_acc_sync_gl.gl_account.required', { ns: 'resources.form-validator' })),
      })
    )
    .test(
      'unique_gl',
      'Same VP can not be assigned to multiple sale accounts',
      (values: any) => {
        const gl_acc: string[] = values
          .filter(
            (value: any) => value['gl_account'] && value['gl_account']['value']
          )
          .map((value: any) => value['gl_account']['value'])

        if (values.length == gl_acc.length) {
          let findDuplicates = gl_acc.filter(
            (item: string, index: number) => gl_acc.indexOf(item) !== index
          )
          return findDuplicates.length ? false : true
        } else {
          return true
        }
      }
    ),
})

export const BankReconcileFormValidate = yup.object().shape({
  beginningBalance: yup
    .string()
    .matches(
      /^-?\d*(\.\d{1,2})?$/,
      i18n.t('bank_reconcile_form.beginning_balance.matches', { ns: 'resources.form-validator' })
    )
    .required(i18n.t('bank_reconcile_form.beginning_balance.required', { ns: 'resources.form-validator' })),
  endingBalance: yup
    .string()
    .matches(
      /^-?\d*(\.\d{1,2})?$/,
      i18n.t('bank_reconcile_form.ending_balance.matches', { ns: 'resources.form-validator' })
    )
    .required(i18n.t('bank_reconcile_form.ending_balance.required', { ns: 'resources.form-validator' })),
})

export const CreateTransactionAdjustmentValidate = yup.object().shape({
  header_description: yup
    .string()
    .required(
      i18n.t('create_transaction_adjustment.header_description.required', {
        ns: 'resources.form-validator',
      })
    )
    .typeError(
      i18n.t('create_transaction_adjustment.description.type_error', {
        ns: 'resources.form-validator',
      })
    ),
  header_amount: yup
    .number()
    .required(
      i18n.t('create_transaction_adjustment.header_amount.required', {
        ns: 'resources.form-validator',
      })
    )
    .moreThan(
      0,
      i18n.t('create_transaction_adjustment.header_amount.more_than', {
        ns: 'resources.form-validator',
      })
    )
    .typeError(
      i18n.t('create_transaction_adjustment.header_amount.type_error', {
        ns: 'resources.form-validator',
      })
    ),
  transaction_adjustment: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          description: yup
            .string()
            .nullable()
            .strict()
            .typeError(
              i18n.t('create_transaction_adjustment.description.type_error', {
                ns: 'resources.form-validator',
              })
            ),
          adjustment_debit: yup
            .number()
            .required(
              i18n.t(
                'create_transaction_adjustment.adjustment_debit.required',
                { ns: 'resources.form-validator' }
              )
            )
            .typeError(
              i18n.t(
                'create_transaction_adjustment.adjustment_debit.type_error',
                { ns: 'resources.form-validator' }
              )
            ),
          adjustment_credit: yup
            .number()
            .required(
              i18n.t(
                'create_transaction_adjustment.adjustment_credit.required',
                { ns: 'resources.form-validator' }
              )
            )
            .typeError(
              i18n.t(
                'create_transaction_adjustment.adjustment_credit.type_error',
                { ns: 'resources.form-validator' }
              )
            ),
          adjustment_master_credit_account_id: yup
            .object()
            .nullable()
            .when('adjustment_credit', {
              is: (val: number) => val > 0,
              then: (schema: any) =>
                schema
                  .shape({
                    label: yup
                      .string()
                      .required(
                        i18n.t(
                          'create_transaction_adjustment.adjustment_master_credit_account_id.label.required',
                          { ns: 'resources.form-validator' }
                        )
                      ),
                    value: yup
                      .string()
                      .required(
                        i18n.t(
                          'create_transaction_adjustment.adjustment_master_credit_account_id.value.required',
                          { ns: 'resources.form-validator' }
                        )
                      ),
                  })
                  .required(
                    i18n.t(
                      'create_transaction_adjustment.adjustment_master_credit_account_id.required',
                      { ns: 'resources.form-validator' }
                    )
                  ),
              otherwise: (schema: any) => schema.nullable(),
            }),
          adjustment_master_debit_account_id: yup
            .object()
            .nullable()
            .when('adjustment_debit', {
              is: (val: number) => val > 0,
              then: (schema: any) =>
                schema
                  .shape({
                    label: yup
                      .string()
                      .required(
                        i18n.t(
                          'create_transaction_adjustment.adjustment_master_debit_account_id.label.required',
                          { ns: 'resources.form-validator' }
                        )
                      ),
                    value: yup
                      .string()
                      .required(
                        i18n.t(
                          'create_transaction_adjustment.adjustment_master_debit_account_id.value.required',
                          { ns: 'resources.form-validator' }
                        )
                      ),
                  })
                  .required(
                    i18n.t(
                      'create_transaction_adjustment.adjustment_master_debit_account_id.required',
                      { ns: 'resources.form-validator' }
                    )
                  ),
              otherwise: (schema: any) => schema.nullable(),
            }),
        })
        .test(
          'different-accounts',
          i18n.t('create_transaction_adjustment.different_accounts', {
            ns: 'resources.form-validator',
            defaultValue: 'Debit and Credit accounts must be different',
          }),
          function (value: any) {
            const {
              adjustment_master_debit_account_id,
              adjustment_master_credit_account_id,
            } = value
            if (
              adjustment_master_debit_account_id?.value &&
              adjustment_master_credit_account_id?.value
            ) {
              return (
                adjustment_master_debit_account_id.value !==
                adjustment_master_credit_account_id.value
              )
            }
            return true
          }
        )
    )
    .test(
      'total-balance',
      i18n.t('create_transaction_adjustment.adjustment_debit.one_of', {
        ns: 'resources.form-validator',
      }),
      (value) => {
        if (!value) return true
        const totalDebit = value.reduce(
          (acc, cur) => acc + (cur.adjustment_debit || 0),
          0
        )
        const totalCredit = value.reduce(
          (acc, cur) => acc + (cur.adjustment_credit || 0),
          0
        )
        return Math.abs(totalDebit - totalCredit) < 0.01
      }
    ),
})

export const PersonalBalanceValidate = yup.object().shape({
  personal_balance_sheet_info_self: yup.object().shape({
    salutation: yup.string(),
    first_name: yup.string(),
    last_name: yup.string(),
    initial: yup.string(),
    current_address: yup.string(),
    current_city: yup.string(),
    current_state: yup.string(),
    current_zip: yup.string(),
    current_country: yup.string(),
    current_social_security_number: yup.string(),
    current_date_of_birth: yup.string(),
    current_residence: yup.string(),
    current_owner_type: yup.string(),
    current_years: yup.number(),
    current_months: yup.number(),
    current_date: yup.string(),
    previous_address: yup.string(),
    previous_city: yup.string(),
    previous_state: yup.string(),
    previous_zip: yup.string(),
    previous_date: yup.string(),
    previous_owner_type: yup.string(),
    previous_years: yup.number(),
    previous_months: yup.number(),
    previous_personal_phone: yup.string(),
    previous_work_phone: yup.string(),
    employer_name: yup.string(),
    employer_address: yup.string(),
    employer_city: yup.string(),
    employer_state: yup.string(),
    employer_zip: yup.string(),
    employer_position: yup.string(),
    employer_title: yup.string(),
    employer_service_yrs: yup.number(),
    employer_service_months: yup.number(),
    previous_employer_name: yup.string(),
    previous_employer_service_yrs: yup.number(),
    previous_employer_service_months: yup.number(),
    previous_employer_wk_phone: yup.string(),
    previous_employer_position: yup.string(),
    previous_employer_title: yup.string(),
    dependants: yup.array().of(
      yup.object().shape({
        name: yup.string(),
        relationship: yup.string(),
      })
    ),
  }),
  personal_balance_sheet_info_spouse: yup.object().shape({
    salutation: yup.string(),
    first_name: yup.string(),
    last_name: yup.string(),
    initial: yup.string(),
    current_address: yup.string(),
    current_city: yup.string(),
    current_state: yup.string(),
    current_zip: yup.string(),
    current_country: yup.string(),
    current_social_security_number: yup.string(),
    current_date_of_birth: yup.string(),
    current_residence: yup.string(),
    current_owner_type: yup.string(),
    current_years: yup.number(),
    current_months: yup.number(),
    current_date: yup.string(),
    previous_address: yup.string(),
    previous_city: yup.string(),
    previous_state: yup.string(),
    previous_zip: yup.string(),
    previous_date: yup.string(),
    previous_owner_type: yup.string(),
    previous_years: yup.number(),
    previous_months: yup.number(),
    previous_personal_phone: yup.string(),
    previous_work_phone: yup.string(),
    employer_name: yup.string(),
    employer_address: yup.string(),
    employer_city: yup.string(),
    employer_state: yup.string(),
    employer_zip: yup.string(),
    employer_position: yup.string(),
    employer_title: yup.string(),
    employer_service_yrs: yup.number(),
    employer_service_months: yup.number(),
    previous_employer_name: yup.string(),
    previous_employer_service_yrs: yup.number(),
    previous_employer_service_months: yup.number(),
    previous_employer_wk_phone: yup.string(),
    previous_employer_position: yup.string(),
    previous_employer_title: yup.string(),
    dependants: yup.array().of(
      yup.object().shape({
        name: yup.string(),
        relationship: yup.string(),
      })
    ),
  }),
  balance_sheet_assets: yup.array().of(
    yup.object().shape({
      description: yup.string(),
      amount: yup.number(),
    })
  ),
  balance_sheet_liabilities: yup.array().of(
    yup.object().shape({
      description: yup.string(),
      amount: yup.number(),
    })
  ),
  personal_balance_sheet_annual_income: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      self_amount: yup.number(),
      spouse_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_one_cash_type: yup.array().of(
    yup.object().shape({
      institution_name: yup.string(),
      title: yup.string(),
      balance_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_one_retirement_type: yup.array().of(
    yup.object().shape({
      institution_name: yup.string(),
      title: yup.string(),
      balance_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_one_certificate_type: yup.array().of(
    yup.object().shape({
      institution_name: yup.string(),
      title: yup.string(),
      balance_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_two_equities: yup.array().of(
    yup.object().shape({
      owner: yup.string(),
      holding_party: yup.string(),
      name_of_portfolio: yup.string(),
      amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_two_equities_loan: yup.array().of(
    yup.object().shape({
      loan_against_portfolio: yup.string(),
      borrower_name: yup.string(),
      guarantor_name: yup.string(),
      loan_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_two_bonds: yup.array().of(
    yup.object().shape({
      owner: yup.string(),
      holding_party: yup.string(),
      name_of_portfolio: yup.string(),
      amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_two_bonds_loan: yup.array().of(
    yup.object().shape({
      loan_against_portfolio: yup.string(),
      borrower_name: yup.string(),
      guarantor_name: yup.string(),
      loan_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_two_securities: yup.array().of(
    yup.object().shape({
      owner: yup.string(),
      holding_party: yup.string(),
      name_of_portfolio: yup.string(),
      amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_two_securities_loan: yup.array().of(
    yup.object().shape({
      loan_against_portfolio: yup.string(),
      borrower_name: yup.string(),
      guarantor_name: yup.string(),
      loan_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_three_life_insurance: yup.array().of(
    yup.object().shape({
      insurance_company_name: yup.string(),
      insured_person_name: yup.string(),
      beneficiary_name: yup.string(),
      term_date: yup.string(),
      term_amount: yup.number(),
      whole_life_amount: yup.number(),
      loan_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_four_receivable_due: yup.array().of(
    yup.object().shape({
      debtor_name: yup.string(),
      description: yup.string(),
      due_date: yup.string(),
      repayment_terms: yup.string(),
      balance_amount: yup.number(),
    })
  ),
  personal_balance_sheet_section_five_real_estate_primary_property: yup
    .array()
    .of(
      yup.object().shape({
        address: yup.string(),
        build_date: yup.number(),
        term: yup.string(),
        due_date: yup.string(),
        monthly_payment_amount: yup.number(),
        purchase_amount: yup.number(),
        market_value_amount: yup.number(),
        mortgage_balance_amount: yup.number(),
      })
    ),
  personal_balance_sheet_section_five_real_estate_other_property: yup
    .array()
    .of(
      yup.object().shape({
        address: yup.string(),
        build_date: yup.number(),
        term: yup.string(),
        due_date: yup.string(),
        monthly_payment_amount: yup.number(),
        purchase_amount: yup.number(),
        market_value_amount: yup.number(),
        mortgage_balance_amount: yup.number(),
      })
    ),
  section_six_profit_sharing: yup.array().of(
    yup.object().shape({
      name: yup.string(),
      account_type: yup.string(),
      value: yup.number(),
      vested: yup.number(),
      loans: yup.number(),
    })
  ),
  section_seven_automobiles: yup.array().of(
    yup.object().shape({
      year: yup.number(),
      make: yup.string(),
      model: yup.string(),
      miles: yup.string(),
      loan_balance: yup.number(),
      apprisal: yup.number(),
      value: yup.number(),
    })
  ),
  section_eight_personal_property: yup.array().of(
    yup.object().shape({
      description: yup.string(),
      insured: yup.string(),
      agent: yup.string(),
      phone: yup.string(),
      apprisal: yup.number(),
      loans: yup.number(),
      value: yup.number(),
    })
  ),
  section_nine_notes: yup.array().of(
    yup.object().shape({
      name: yup.string(),
      date_borrowed: yup.string(),
      amount_borrowed: yup.number(),
      due_date: yup.string(),
      payment: yup.number(),
      balance: yup.number(),
    })
  ),
  section_nine_other_notes: yup.array().of(
    yup.object().shape({
      name: yup.string(),
      date_borrowed: yup.string(),
      amount_borrowed: yup.number(),
      due_date: yup.string(),
      payment: yup.number(),
      balance: yup.number(),
    })
  ),
  section_ten: yup.array().of(
    yup.object().shape({
      name: yup.string(),
      high_balance: yup.number(),
      start_date: yup.string(),
      end_date: yup.string(),
      payment: yup.number(),
    })
  ),
})

export const PersonalIncomeValidate = yup.object().shape({
  section_one_primary_income: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      monthly_amount: yup.number(),
      annual_amount: yup.number(),
      notes: yup.string(),
    })
  ),
  section_one_other_income: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      monthly_amount: yup.number(),
      annual_amount: yup.number(),
      notes: yup.string(),
    })
  ),
  section_two_fixed_expense: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      monthly_amount: yup.number(),
      annual_amount: yup.number(),
      notes: yup.string(),
    })
  ),
  section_two_variable_expense: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      monthly_amount: yup.number(),
      annual_amount: yup.number(),
      notes: yup.string(),
    })
  ),
  section_three_investments: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      monthly_amount: yup.number(),
      annual_amount: yup.number(),
      notes: yup.string(),
    })
  ),
  section_four_budgets: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      monthly_amount: yup.number(),
      annual_amount: yup.number(),
      notes: yup.string(),
    })
  ),
})

export const OpenningBalanceValidate = yup.object().shape({
  assets: yup.array().of(
    yup.object().shape({
      opening_balance: yup.string(),
      account: yup.number(),
      name: yup.string().required(i18n.t('openning_balance.assets.name.required', { ns: 'resources.form-validator' })),
      description: yup.string(),
      report_code: yup.string(),
      financial_statement: yup.string(),
      master_chart_of_account_id: yup.number(),
      credit: yup.string(),
      debit: yup.string(),
    })
  ),
  liabilities: yup.array().of(
    yup.object().shape({
      opening_balance: yup.string(),
      account: yup.number(),
      name: yup.string().required(i18n.t('openning_balance.liabilities.name.required', { ns: 'resources.form-validator' })),
      description: yup.string(),
      report_code: yup.string(),
      financial_statement: yup.string(),
      master_chart_of_account_id: yup.number(),
      credit: yup.string(),
      debit: yup.string(),
    })
  ),
})

export const CreditCardClassificationValidate = yup.object().shape({
  classifications: yup.array().of(
    yup.object().shape({
      checked: yup.boolean(),
      id: yup.number(),
      description: yup.string().nullable(),
      transaction_at: yup.string(),
      adjustment_debit: yup.number(),
      adjustment_credit: yup.number(),
      adjustment_master_debit_account_id: yup
        .object()
        .when(['adjustment_debit', 'checked'], {
          is: (deposit: number, isChecked: boolean) => {
            return +deposit && isChecked
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('credit_card_classification.adjustment_master_debit_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('credit_card_classification.adjustment_master_debit_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('credit_card_classification.adjustment_master_debit_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('credit_card_classification.adjustment_master_debit_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      adjustment_master_credit_account_id: yup
        .object()
        .when(['deposit', 'checked'], {
          is: (deposit: number, isChecked: boolean) => {
            return +deposit && isChecked
          },
          then: (schema: any) =>
            schema
              .shape({
                label: yup.string().required(i18n.t('credit_card_classification.adjustment_master_credit_account_id.label.required', { ns: 'resources.form-validator' })),
                value: yup.string().required(i18n.t('credit_card_classification.adjustment_master_credit_account_id.value.required', { ns: 'resources.form-validator' })),
              })
              .typeError(i18n.t('credit_card_classification.adjustment_master_credit_account_id.type_error', { ns: 'resources.form-validator' }))
              .required(i18n.t('credit_card_classification.adjustment_master_credit_account_id.required', { ns: 'resources.form-validator' })),
          otherwise: (schema: any) => schema.nullable(),
        }),
      duplicate: yup.boolean(),
      posted: yup.boolean(),
      allow_to_post: yup.boolean(),
    })
  ),
})

export const QuickBookCOAValidate = yup.object().shape({
  coa: yup.array().of(
    yup.object().shape({
      checked: yup.boolean(),
      id: yup.number(),
      // parent_id: yup.number(),
      name: yup.string().nullable(),
      accountType: yup.string().nullable(),
      classification: yup.string(),
      account_id: yup
        .object()
        .shape({
          label: yup.string().required(
            i18n.t('quickbook_coa.account_id.label.required', {
              ns: 'resources.form-validator',
            })
          ),
          value: yup.string().required(
            i18n.t('quickbook_coa.account_id.value.required', {
              ns: 'resources.form-validator',
            })
          ),
        })
        .required(
          i18n.t('quickbook_coa.account_id.required', {
            ns: 'resources.form-validator',
          })
        ),
    })
  ),
})

export const QuickBookBSPLValidate = yup.object().shape({
  BS_PL: yup.array().of(
    yup.object().shape({
      checked: yup.boolean(),
      field_id: yup.number(),
      month: yup.number(),
      year: yup.number(),
    })
  ),
})

// REV-586 — True double-entry journal entry validation
export const JournalEntryValidate = yup.object().shape({
  header_description: yup
    .string()
    .required(
      i18n.t('journal_entry.header_description.required', {
        ns: 'resources.form-validator',
      })
    )
    .typeError(
      i18n.t('journal_entry.header_description.required', {
        ns: 'resources.form-validator',
      })
    ),

  transaction_at: yup
    .date()
    .required(
      i18n.t('journal_entry.transaction_at.required', {
        ns: 'resources.form-validator',
      })
    )
    .typeError(
      i18n.t('journal_entry.transaction_at.type_error', {
        ns: 'resources.form-validator',
      })
    ),

  rows: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          master_chart_of_account_id: yup.object().nullable().default(null),
          debit_amount: yup.number().min(0).default(0),
          credit_amount: yup.number().min(0).default(0),
          notes: yup.string().nullable().default(''),
        })
        .test(
          'exactly-one-side',
          i18n.t('journal_entry.row.exactly_one_side', {
            ns: 'resources.form-validator',
          }),
          (row) => {
            const d = row?.debit_amount ?? 0
            const c = row?.credit_amount ?? 0
            // Both sides filled on same row is not allowed
            return !(d > 0 && c > 0)
          }
        )
        .test(
          'account-required-when-amount',
          i18n.t('journal_entry.row.account_required', {
            ns: 'resources.form-validator',
          }),
          (row) => {
            const hasAmount =
              (row?.debit_amount ?? 0) > 0 || (row?.credit_amount ?? 0) > 0
            const account = row?.master_chart_of_account_id as any
            if (hasAmount && !account?.value) return false
            return true
          }
        )
    )
    .min(
      2,
      i18n.t('journal_entry.rows.min', { ns: 'resources.form-validator' })
    )
    .test(
      'min-one-debit',
      i18n.t('journal_entry.rows.need_debit', {
        ns: 'resources.form-validator',
      }),
      (rows) => {
        if (!rows) return true
        return rows.some((r) => (r.debit_amount || 0) > 0)
      }
    )
    .test(
      'min-one-credit',
      i18n.t('journal_entry.rows.need_credit', {
        ns: 'resources.form-validator',
      }),
      (rows) => {
        if (!rows) return true
        return rows.some((r) => (r.credit_amount || 0) > 0)
      }
    )
    .test(
      'balanced',
      i18n.t('journal_entry.rows.unbalanced', {
        ns: 'resources.form-validator',
      }),
      (rows) => {
        if (!rows) return true
        const totalDebit = rows.reduce((s, r) => s + (r.debit_amount || 0), 0)
        const totalCredit = rows.reduce((s, r) => s + (r.credit_amount || 0), 0)
        return Math.abs(totalDebit - totalCredit) < 0.01
      }
    ),
})